import {createLogger} from '../../common/logging.config';
const logger = createLogger('shell-data-homepage-service');

module.exports = ['$http', '$q', function($http, $q) {	// NOSONAR

	const whatsNewURL = '/api/ui-interface/v1/whats-new';

	// This module will be used rather than going directly with shellDataService as we want to
	// only track preference data and keep this cached promise independent of the other data used
	// with shell-ui functionality
	//
	// We were forced to use the shell-data whats-new endpoint as new databases aren't allowed in 
	// WCH and homepage data was left out like a second-class passenger that missed the boat
	let whatsNewPromise = null;

	
	/**
	 * Retrieve widget preference data for the current user.
	 *
	 * @returns {*}
	 */
	function getWhatsNewData() {
		if (!whatsNewPromise) {
			whatsNewPromise = $http.get(whatsNewURL).then(
				(res) => {
					logger.info('Received whats new data for the current user:' + JSON.stringify(res.data));
					return res.data;
				},
				(res) => $q.reject(res.status + ': ' + res.statusText)
			);
		}
		return whatsNewPromise;
	}

	/**
	 * Set widget preference data for the current user.
	 * This is now a generic function to store the whats-new data.
	 * @param {Object} settings, this object stores the user preferences.
	 * @returns {*}
	 */
	function setWhatsNewData(settings={}) {
		whatsNewPromise = null;
		// do not post without settings as this will update the whats-new timestamp
		if (settings !== {}) {
			return $http.post(whatsNewURL, settings).then(
					(res) => $q.resolve(res),
					(res) => $q.reject(res.status + ': ' + res.statusText)
			);
		}
		else {
			Promise.reject(new Error('settings was empty, need to supply widget preference data'));
		}
	}
	

	// return public API for the REST factory
	return {
		getUserPreferences: getWhatsNewData,
		setUserPreferences: setWhatsNewData
	};
}];



// WEBPACK FOOTER //
// ./app/common/services/shell-data-homepage-service.factory.js